module.exports = __webpack_public_path__ + "fonts/brandon-bold.af9de16.ttf";